var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-actions" },
    [
      _c(
        "button",
        {
          staticClass: "home-actions__btn",
          attrs: { type: "button" },
          on: { click: _vm.openHowGameWorksDialog },
        },
        [_vm._m(0)]
      ),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom-end",
            trigger: "click",
            width: "300",
            "popper-class": "home-actions-popover",
            "visible-arrow": false,
          },
          model: {
            value: _vm.settingsState.isSettingsTooltipOpen,
            callback: function ($$v) {
              _vm.$set(_vm.settingsState, "isSettingsTooltipOpen", $$v)
            },
            expression: "settingsState.isSettingsTooltipOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "popover-settings-content" },
            [
              _vm._t("settings", function () {
                return [
                  _c(
                    "div",
                    { staticClass: "setting-row" },
                    [
                      _c("span", [_vm._v("关闭动画")]),
                      _c("el-switch", {
                        attrs: { width: 150 },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("animations-change", $event)
                          },
                        },
                        model: {
                          value: _vm.settingsState.disableAnimations,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settingsState,
                              "disableAnimations",
                              $$v
                            )
                          },
                          expression: "settingsState.disableAnimations",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "setting-row" },
                    [
                      _c("span", [_vm._v("关闭音效")]),
                      _c("el-switch", {
                        attrs: { width: 150 },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("sound-change", $event)
                          },
                        },
                        model: {
                          value: _vm.settingsState.disableChickenRoadSounds,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settingsState,
                              "disableChickenRoadSounds",
                              $$v
                            )
                          },
                          expression: "settingsState.disableChickenRoadSounds",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "setting-row" },
                    [
                      _c("span", [_vm._v("关闭音乐")]),
                      _c("el-switch", {
                        attrs: { width: 150 },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("music-change", $event)
                          },
                        },
                        model: {
                          value: _vm.settingsState.disableChickenRoadMusic,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.settingsState,
                              "disableChickenRoadMusic",
                              $$v
                            )
                          },
                          expression: "settingsState.disableChickenRoadMusic",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
          _c(
            "button",
            {
              staticClass: "home-actions__btn home-actions__btn--settings",
              attrs: { slot: "reference", type: "button" },
              slot: "reference",
            },
            [
              _c("div", { staticClass: "home-actions__inner" }, [
                !_vm.settingsState.isSettingsTooltipOpen
                  ? _c("i", {
                      staticClass: "icon icon_gear-bold home-actions__icon",
                    })
                  : _c("i", {
                      staticClass: "icon icon_close-bold home-actions__icon",
                    }),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "home-actions__inner home-actions__inner--padded" },
      [_c("span", { staticClass: "home-actions__text" }, [_vm._v("游戏规则")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }